module.exports = __webpack_public_path__ + "img/new-unit-pic.5b8c8f02.png";